// Template literal type to enforce dynamic placeholder format
export type DynamicPlaceholder = `{{${string}}}`;

// Type for dynamic options with enforced key format
export type DynamicOptions = Record<DynamicPlaceholder, string>;

export { GenericUtmField } from './generic-utm-field';
export { GenericUtmParametersGroup } from './generic-utm-parameters-group';

// Re-export the UTM utilities for convenience
export {
  DYNAMIC_UTM_OPTIONS,
  resolveUtmParameters,
  buildUrlWithUtm,
  type DynamicParameterContext,
  type UtmParameters,
  type CustomUtmParameter,
} from '../../utils/utmUtils';
